import { useState } from "react";
import { ExternalLink } from "lucide-react";
import { useReOS } from "./domain/store";
import type { ReOSNotification } from "./domain/types";
import { Button } from "./components/ui/button";
import { Alert } from "./components/ui/alert";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogBody, DialogFooter } from "./components/ui/dialog";

export function EbayOrderIssueDialog({ notification, onClose }: { notification: ReOSNotification; onClose: () => void }) {
  const store = useReOS();
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(false);
  async function markReviewed() {
    setSaving(true); setError(false);
    try { await store.markNotificationRead(notification.id); onClose(); }
    catch { setError(true); }
    finally { setSaving(false); }
  }
  return <Dialog open onOpenChange={(open) => { if (!open && !saving) onClose(); }}>
    <DialogContent presentation="compact" showClose={!saving}>
      <DialogHeader><DialogTitle>Check eBay order</DialogTitle><DialogDescription>Order {notification.marketplaceSignal?.externalOrderID}</DialogDescription></DialogHeader>
      <DialogBody>
        {error && <Alert tone="danger" role="alert">Could not save this review. Try again.</Alert>}
        <p>{notification.body}</p>
        <Button variant="secondary" asChild><a href="https://www.ebay.co.uk/sh/ord" target="_blank" rel="noopener noreferrer">Open eBay orders<ExternalLink aria-hidden="true" /></a></Button>
      </DialogBody>
      <DialogFooter><Button variant="secondary" disabled={saving} onClick={onClose}>Leave for later</Button><Button disabled={saving} onClick={() => void markReviewed()}>{saving ? "Saving…" : "Mark reviewed"}</Button></DialogFooter>
    </DialogContent>
  </Dialog>;
}
